import processContent from '../content/process.json';

export interface ProcessStep { number: string; title: string; description: string; items?: string[]; followUp?: string; }
interface ProcessContent {
  hero: { title: string; lead: string; supporting: string };
  home: ProcessStep[];
  detailed: ProcessStep[];
  principles: Array<{ title: string; description: string }>;
  agency: { title: string; intro: string; proposition: string; body: string; points: string[]; closing: string };
  cta: { title: string; description: string };
}

export const processConfig = processContent as ProcessContent;
export const homeProcessSteps = processConfig.home;
export const detailedProcessSteps = processConfig.detailed;
